import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { apiRequest } from "../../Redux/apiActions";
import OtpVerification from "./OtpVerifaction";
import PhoneNumberPage from "./PhoneNumberPage";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import { useLocation, useNavigate } from "react-router-dom";
import { useApiRequest } from "./Hooks/useApiRequest";
import { navbar } from "@material-tailwind/react";

const UserListContainer = () => {
  const dispatch = useDispatch();
  const { makeApiRequest } = useApiRequest();
  const generatedUUID = uuidv4();
  const navigate = useNavigate();
  const location = useLocation();
  const BASE_URL = "https://jsonplaceholder.typicode.com";

  // Redux state
  const users = useSelector((state) => state.api.data?.users || []);
  const authResponse = useSelector((state) => state.api.data?.authenticateUser);
  const authError = useSelector((state) => state.api.error?.authenticateUser);

  // Local state
  const [mobileNo, setMobileNo] = useState("");
  const [authLoading, setAuthLoading] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [isOTPScreen, setIsOTPScreen] = useState(false);
  const [requestId, setRequestId] = useState(null);

  const params = new URLSearchParams(location.search);
  const tagOrderId = params.get("value");
  //console.log("tagOrderId----",tagOrderId)
  const machineId=params.get("machineId")

const route = params.get("route");

let value = null;

if (route && route.includes("value=")) {
  value = route.split("value=")[1];
}

//console.log("value---",value);
  const uuid=params.get("value")



  useEffect(() => {
    setIsButtonDisabled(!/^\d{10}$/.test(mobileNo));
  }, [mobileNo]);
  useEffect(()=>{

    const jwt =localStorage.getItem("UserJWTAuth");
        const Guest_clientId =localStorage.getItem("Guest_clientId");
    if(jwt){
      if(!Guest_clientId)
      navigate("/")
    }
  },[])

  useEffect(() => {
    if (authResponse) {
      setIsOTPScreen(true);
      setAuthLoading(false);
     // console.log("authResponse", authResponse.response.requestId);
    }
  }, [authResponse]);

  // Fetch users example
  useEffect(() => {
    makeApiRequest({
      url: `${BASE_URL}/users`,
      method: "GET",
      headers: { "Custom-Header": "my-custom-header" },
      onSuccess: "users",
      onError: "users",
    });
  }, []);

  // Handle mobile authentication
  const handleAuthenticate = () => {
    if (isButtonDisabled) return;
    setAuthLoading(true);

    makeApiRequest({
      url: "https://api-prod.daalchini.co.in/auth/user/authenticate",
      method: "POST",
      data: { request: { mobileNo } },
      headers: {
        accept: "application/json, text/plain, */*",
        "content-type": "application/json",
      },
      onSuccessKey: "authenticateUser",
      onErrorKey: "authenticateUser",
      handleSuccess: (res) => {
        const reqId = res?.data?.response?.requestId;
        //console.log("res",res.data)
        if (reqId) setRequestId(reqId);
        setIsOTPScreen(true);
        setAuthLoading(false);
      },
      handleError: (err) => {
        //console.error("Auth Error:", err);
        setAuthLoading(false);
      },
    });
  };

  // Handle OTP verification
  const handleSubmitOtp = (otp) => {
    makeApiRequest({
      url: "https://api-prod.daalchini.co.in/auth/user/login",
      method: "POST",
      data: { request: { mobileNo, requestId, otp } },
      headers: {
        "x-app-platform": "web",
          "x-app-version": "v1.0.1",
        "x-device-id": localStorage.getItem("uuid") || "",
         "guest-cart-id": localStorage.getItem("card_id") || ""

      },
      onSuccessKey: "otp",
      onErrorKey: "otp",
      handleSuccess: (res) => {
         localStorage.setItem("uuid",generatedUUID)
        //console.log("OTP ",res.data.successful==false)
        if(res.data.successful=="false"){
           toast.error(res.data.statusMessage);
           return 
        }
        if (res.data.successful) {
          localStorage.removeItem("Guest_clientId");
          toast.success("OTP verified successfully!", { autoClose: 1500 });

          localStorage.setItem("UserJWTAuth",res?.data?.response?.jwt)
           localStorage.setItem("referCode",res?.data?.response?.referCode)
           localStorage.setItem("UserId",res?.data?.response?.userId)
            localStorage.setItem("defaultPgId",9)
            localStorage.setItem("defaultPgName","WALLET_LOYALTY")
            localStorage.removeItem("google_jwt")
            
            
          
          //if (tagOrderId) window.location.href = `/tagOrderId?value=${tagOrderId}`;
          //if(machineId) window.location.href = `/items?machineId=${machineId}&value=${null}&showItems=true`;
           //if(uuid) window.location.href = `/items?machineId=${false}&value=${uuid}&showItems=true`;
         // console.log("Login-------------------",route, machineId);
           if(route) {
            // console.log("-----------------")
            localStorage.removeItem("Guest_clientId")
            localStorage.removeItem("Guest_OauthToken")
            const params = new URLSearchParams(location.search);

            const route = params.get("route");       // "myCart"
            const machineId = params.get("machineId"); // "8"

            //console.log("Login -------------------",route, machineId);
           navigate(`/${route}?machineId=${machineId}`)
          }
       }
       if(route==null){
        //console.log("-----------------")
        navigate('/')
       }

      },
      handleError: (err) => {
        toast.error(err?.message || "OTP verification failed");
      },
    });
  };

  // Handle Skip Login
  const handleSkipLogin = () => {
    localStorage.setItem("defaultPgName", "WALLET_LOYALTY");
    localStorage.setItem("defaultPgId", 9);

    makeApiRequest({
      url: "https://api-prod.daalchini.co.in/auth/user/guest/login",
      method: "POST",
      data: { request: { clientId: null } },
      headers: {
        Authorization: `Bearer ${localStorage.getItem("UserJWTAuth")}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
      },
      handleSuccess: (res) => {
        //console.log("res",res.data.response)
        if (res.data.successful){

           toast.success("Guest login successful!");
             localStorage.setItem("uuid",generatedUUID)



  localStorage.setItem("Guest_clientId",res.data.response.clientId)
  localStorage.setItem("Guest_OauthToken",res.data.response.oauthToken)

  localStorage.setItem("UserJWTAuth",res.data.response.jwt)

  localStorage.setItem("Guest_OauthToken",res.data.response.oauthToken)
  localStorage.setItem("defaultPgId",9)
  localStorage.setItem("defaultPgName","WALLET_LOYALTY")
          
          if(route) {
            // console.log("-----------------")
            localStorage.removeItem("Guest_clientId")
            localStorage.removeItem("Guest_OauthToken")
            const params = new URLSearchParams(location.search);

            const route = params.get("route");       // "myCart"
            const machineId = params.get("machineId"); // "8"

           // console.log("Login -------------------",route, machineId);
           navigate(`/${route}?machineId=${machineId}`)
          }
       
       if(route==null){
        //console.log("-----------------")
        navigate('/')
       }



        }

        else toast.error(res.statusMessage || "Guest login failed");
      },
      handleError: (err) => {
       // console.log("error-------------->",err)
        
        toast.error(err?.message || "Something went wrong")},
    });
  };

  // Handle Google Login
  const onGoogleSuccess = (response) => {
    //console.log("response",response?.profileObj)
    localStorage.setItem("gmail",response?.profileObj?.email)
   

    if (response.error) {
      toast.error("Google login failed");
      return;
    }

    localStorage.setItem("uuid", localStorage.getItem("uuid") || crypto.randomUUID());
    localStorage.setItem("gmail", response.profileObj.email);
makeApiRequest({
  url: "https://api-prod.daalchini.co.in/auth/user/google/login",
  method: "POST",
  data: {
    googleIdToken: response.tokenId   // SAME AS CURL BODY
  },
  headers: {
    "x-app-platform": "web",
    "x-app-version": "v1.0.1",
    "x-device-id": localStorage.getItem("uuid") || "",
    "guest-cart-id": localStorage.getItem("card_id") || ""
  },
  handleSuccess: (res) => {
   // console.log("google res-------", res);

    if (res.data.successful) {

      localStorage.removeItem("Guest_clientId");
      localStorage.setItem("UserJWTAuth", res.data.response.jwt);
      localStorage.setItem("google_jwt", res.data.response.jwt);
      localStorage.setItem("Guest_OauthToken", res.data.response.oauthToken);
      localStorage.setItem("defaultPgId", 9);
      localStorage.setItem("defaultPgName", "WALLET_LOYALTY");

      toast.success("Google login successful!");
      navigate("/");
    }
  },
  handleError: (err) => {
    toast.error(err?.message || "Something went wrong");
  }
});

  };

  if (isOTPScreen) {
    return (
      <OtpVerification
        setIsOTPScreen={setIsOTPScreen}
        resendCode={handleAuthenticate}
        handleSubmitOtp={handleSubmitOtp}
        tagOrderId={tagOrderId}
      />
    );
  }

  return (
    <PhoneNumberPage
      handleAuthenticate={handleAuthenticate}
      setMobileNo={setMobileNo}
      isButtonDisabled={isButtonDisabled}
      mobileNo={mobileNo}
      onGoogleSuccess={onGoogleSuccess}
      handleSkipLogin={handleSkipLogin}
      tagOrderId={tagOrderId}
    />
  );
};

export default UserListContainer;
